import "./App.css";
import Game from "./components";
import "./components.css";

function App() {
  return (
    <div className="App">
      <Game />
    </div>
  );
}

export default App;
